module.exports = __webpack_public_path__ + "img/categorie-nos-engagements-medium.1eb695cc.jpg";